import React, { useEffect, useState } from "react";
import { FaDownload, FaCogs, FaShieldAlt } from "react-icons/fa";
import HTMLFlipBook from "react-pageflip";
import { motion } from "framer-motion";

import finalBanner from "../assets/finalbanner.png";
import brochureImage from "../assets/cata.png";
import brochurePdf from "../assets/Catalogue-Transformer Oil Pumps-14.09.2020.pdf";

import "./Downloads.css";

const Downloads = () => {
  const [showPdf, setShowPdf] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);

    const observer = new IntersectionObserver(
      (entries) =>
        entries.forEach(
          (e) => e.isIntersecting && e.target.classList.add("reveal-visible")
        ),
      { threshold: 0.15 }
    );

    document
      .querySelectorAll(".reveal-on-scroll")
      .forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const handleDownload = () => {
    setDownloading(true);
    setProgress(0);

    const timer = setInterval(() => {
      setProgress((p) => {
        if (p >= 100) {
          clearInterval(timer);
          setDownloading(false);
          const a = document.createElement("a");
          a.href = brochurePdf;
          a.download = "Flowtech-Product-Catalogue.pdf";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          return 100;
        }
        return p + 10;
      });
    }, 150);
  };

  return (
    <div className="ft-catalog-page">
      {/* HERO */}
      <section
  className="hud-hero"
  style={{
    backgroundImage: `
      linear-gradient(
        to bottom,
        rgba(143, 182, 243, 0.65), /* light blue overlay (top) */
        rgba(214, 230, 250, 0.55), /* soft blue overlay (middle) */
        rgba(255, 255, 255, 0.75)  /* white overlay (bottom) */
      ),
      url(${finalBanner})
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
>
  <div className="hero-content">
   <motion.h1
  className="hero-main-title"
  initial={{ opacity: 0, x: -60 }}
  animate={{ opacity: 1, x: 0 }}
  transition={{ duration: 0.9, ease: "easeOut" }}
>
 PRODUCT  CATALOG
</motion.h1>

  </div>
</section>

      {/* CONTENT */}
      <section className="ft-catalog-content">
        <div className="ft-container">
          <div className="ft-brochure-wrapper reveal-on-scroll">
            {/* IMAGE */}
            <div
              className="ft-image-frame"
              onClick={() => setShowPdf(true)}
            >
              <img
                src={brochureImage}
                alt="Product Catalogue"
                className="ft-main-brochure"
              />
            </div>

            {/* INFO */}
            <div className="glass-panel">
              <h2 className="content-heading">
                Product <span className="text-blue">Catalogue</span>
              </h2>

              <p className="ft-desc">
                Download our complete technical catalogue covering Transformer
                Oil Pumps, Traction Pumps, and Marine Pumping Solutions.
              </p>

              <ul className="ft-spec-list">
                <li><FaCogs /> IEC • ISO • ANSI • API compliant designs</li>
                <li><FaShieldAlt /> Trusted by Railways, Power & Defense</li>
                <li><FaDownload /> Detailed curves & GA drawings</li>
              </ul>

              <button className="ft-download-btn" onClick={handleDownload}>
                {downloading
                  ? `Downloading ${progress}%`
                  : "Download Catalogue (PDF)"}
              </button>

              {downloading && (
                <div className="download-bar">
                  <div style={{ width: `${progress}%` }} />
                </div>
              )}
            </div>
          </div>

          {/* KPI */}
          <div className="kpi-strip reveal-on-scroll">
            <div className="kpi-item"><h3>33+</h3><p>Years Exp</p></div>
            <div className="kpi-item"><h3>ISO</h3><p>9001:2015</p></div>
            <div className="kpi-item"><h3>60+</h3><p>Engineers</p></div>
            <div className="kpi-item"><h3>Global</h3><p>Reach</p></div>
          </div>
        </div>
      </section>

      {/* PDF MODAL */}
      {showPdf && (
        <div className="pdf-modal" onClick={() => setShowPdf(false)}>
          <div
            className="pdf-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <HTMLFlipBook width={360} height={520}>
              {[1, 2, 3, 4].map((p) => (
                <div className="page" key={p}>
                  <iframe
                    src={`${brochurePdf}#page=${p}`}
                    title={`page-${p}`}
                  />
                </div>
              ))}
            </HTMLFlipBook>
          </div>
        </div>
      )}
    </div>
  );
};

export default Downloads;
